export const USER_VERTICALS_STORAGE_KEY = "user_verticals";

export const storeUserVerticals = (verticals) => {
  localStorage.setItem(
    USER_VERTICALS_STORAGE_KEY,
    JSON.stringify(verticals || []),
  );
};

export const getUserVerticals = () => {
  try {
    const stored = localStorage.getItem(USER_VERTICALS_STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
};

export const getGatewayTenantIdsForVertical = (verticalId) => {
  const verticals = getUserVerticals();

  return (
    verticals.find(
      (vertical) => Number(vertical.vertical_id) === Number(verticalId),
    )?.tenant_ids ?? []
  );
};
